import React, { useMemo } from "react";
import { fromJalaliDate, jalaliDateParts, toPersianDigits } from "../utils/persianDisplay";

const months = ["فروردین","اردیبهشت","خرداد","تیر","مرداد","شهریور","مهر","آبان","آذر","دی","بهمن","اسفند"];
const style = { minWidth: 0, width: "100%", padding: "9px 5px", border: "1px solid #E4E4EC", borderRadius: 8, background: "#fff", fontFamily: "inherit" };
export default function JalaliDatePicker({ value, onChange, required = false, disabled = false }) {
  const parts = useMemo(() => jalaliDateParts(value) || [], [value]);
  const currentYear = jalaliDateParts(new Date().toISOString().slice(0, 10))?.[0] || 1405;
  const years = Array.from({ length: 21 }, (_, i) => currentYear - 10 + i);
  const setPart = (index, text) => {
    const next = parts.length === 3 ? [...parts] : [...(jalaliDateParts(new Date().toISOString().slice(0, 10)) || [currentYear, 1, 1])];
    next[index] = Number(text);
    if (!next.every(Boolean)) return;
    const iso = fromJalaliDate(...next);
    if (iso) onChange(iso);
  };
  return <div dir="rtl" style={{display:"grid",gridTemplateColumns:"1fr 1.5fr 1.2fr",gap:6}}>
    <select aria-label="روز" disabled={disabled} required={required} value={parts[2] || ""} onChange={e => setPart(2, e.target.value)} style={style}>
      <option value="">روز</option>{Array.from({length:31},(_,i)=>i+1).map(d=><option key={d} value={d}>{toPersianDigits(d)}</option>)}
    </select>
    <select aria-label="ماه" disabled={disabled} required={required} value={parts[1] || ""} onChange={e => setPart(1, e.target.value)} style={style}>
      <option value="">ماه</option>{months.map((m,i)=><option key={m} value={i+1}>{m}</option>)}
    </select>
    <select aria-label="سال" disabled={disabled} required={required} value={parts[0] || ""} onChange={e => setPart(0, e.target.value)} style={style}>
      <option value="">سال</option>{years.map(y=><option key={y} value={y}>{toPersianDigits(y)}</option>)}
    </select>
  </div>;
}
